module.exports = __webpack_public_path__ + "static/media/7_r_kadirova91.15_77.22.c9320092.png";